/**
 * created by lei lei
 * sys 管理路由
 *
 */
import RoleList from "../organizationalStructure/role/RoleList";
import UserList from "../organizationalStructure/UserList/UserList";
import DeptList from "../organizationalStructure/dept/DeptList";
import MenuList from "../organizationalStructure/menu/MenuList";
import PermissionList from "../organizationalStructure/permission/PermissionList";
import ProcessList from '../processManagement/processList.jsx'
import ParamConfiguration from "../paramConfiguration/ParamConfiguration";
import PasswordConfiguration from "../passwordConfiguration/PasswordConfiguration";
import SuspendAccount from "../suspendAccount/SuspendAccount";
import MessageCenter from "../messageCenter/MessageCenter";
import ProcessCenterUntreated from "../processCenterUntreated/ProcessCenterUntreated";
import SystemSetup from "../systemSetup/SystemSetup";
import VisitLog from "../visitLog/VisitLog";
import SysLog from "../sysLog/SysLog";
import OnlineNumberInfo from "../onlineNumberInfo/OnlineNumberInfo";
import SensitiveWordSettings from "../sensitiveWordSettings/SensitiveWordSettings";
import NoticeTemplateManager from "../noticeTemplateManager/NoticeTemplateManager";
import BaseDataImport from "../baseDataImport/BaseDataImport";
import ResourceSettings from "../resourceSettings/ResourceSettings";
import WatermarkManage from "../watermarkManage/WatermarkManage";

export const sysRouter = [
    {
        path: "/view/sysManagement/roleList",
        componentTitle: "sys角色",
        component: RoleList
    },
    {
        path: "/view/sysManagement/userList",
        componentTitle: "sys用户管理",
        component: UserList
    },
    {
        path: "/view/sysManagement/deptList",
        componentTitle: "sys部门",
        component: DeptList
    },
    {
        path: "/view/sysManagement/menuList",
        componentTitle: "sys菜单",
        component: MenuList,
    },
    {
        path: "/view/sysManagement/permissionList",
        componentTitle: "sys权限",
        component: PermissionList
    },
    {
        path: "/view/sysManagement/paramConfiguration",
        componentTitle: "sys配置管理",
        component: ParamConfiguration
    },
    {
        path: "/view/sysManagement/processList",
        componentTitle: "sys流程管理",
        component: ProcessList
    },
    {
        path: "/view/sysManagement/passwordConfiguration",
        componentTitle: "sys密码配置",
        component: PasswordConfiguration
    },
    {
        path: "/view/sysManagement/suspendAccount",
        componentTitle: "sys账号冻结",
        component: SuspendAccount
    },
    {
        path: "/view/sysManagement/messageCenter",
        componentTitle: "sys消息中心",
        component: MessageCenter,
    },
    {
        path: "/view/sysManagement/processCenterUntreated", // 流程中心-待我处理
        componentTitle: "sys流程中心",
        component: ProcessCenterUntreated,
    },
    {
        path: "/view/sysManagement/systemSetup", // 系统设置
        componentTitle: "sys系统设置",
        component: SystemSetup,
    },
    {
        path: "/view/sysManagement/visitLog", // 安全配置-平台日志
        componentTitle: "sys平台日志",
        component: VisitLog,
    },
    {
        path: "/view/sysManagement/sysLog", // 安全配置-在线用户访问日志
        componentTitle: "sys在线用户访问日志",
        component: SysLog,
    },
    {
        path: "/view/sysManagement/onlineNumberInfo", // 安全配置-在线用户列表
        componentTitle: "sys在线用户列表",
        component: OnlineNumberInfo,
    },
    {
        path: "/view/sysManagement/sensitiveWordSettings", // 安全配置-敏感词设置
        componentTitle: "sys敏感词设置",
        component: SensitiveWordSettings,
    },
    {
        path: "/view/sysManagement/noticeTemplateManager", // 安全配置-消息模板
        componentTitle: "sys消息模板",
        component: NoticeTemplateManager,
    },
    {
        path: "/view/sysManagement/baseDataImport", // 安全配置-基础数据导入导出
        componentTitle: "sys基础数据导入导出",
        component: BaseDataImport,
    },
    {
        path: "/view/sysManagement/resourceSettings", // 基础数据-资源库设置
        componentTitle: "sys资源库设置",
        component: ResourceSettings,
    },
    {
        path: "/view/sysManagement/watermarkManage", // 基础数据-水印管理
        componentTitle: "sys水印管理",
        component: WatermarkManage,
    }
];
